/** Powód, dla którego akcja została odrzucona. Trafia do klienta jako komunikat. */
export class IllegalActionError extends Error {
    constructor(message) {
        super(message);
        this.name = "IllegalActionError";
    }
}
//# sourceMappingURL=plugin.js.map